import type { ITicketAssetFinanceFinance } from './TicketAssetFinanceFinance.interface';

export default class TicketAssetFinanceFinance implements ITicketAssetFinanceFinance {
  financeAmount: number;
  accountNumber: string;
  interestRate: number;
  balloonAmount: number;
  brokerMargin: number;
  financeTeam: number;
  applicationFees: number;

  static build = (data: ITicketAssetFinanceFinance) => new TicketAssetFinanceFinance(data);
  static blank = () => new TicketAssetFinanceFinance();

  /**
   * Constructor
   * @param {ITicketAssetFinanceFinance} data
   */
  constructor(data?: ITicketAssetFinanceFinance) {
    this.financeAmount = parseFloat(data?.financeAmount || 0);
    this.accountNumber = data?.accountNumber || '';
    this.interestRate = parseFloat(data?.interestRate || 0);
    // TODO: data?.ballonAmount is legacy data structure
    this.balloonAmount = parseFloat(data?.ballonAmount || data?.balloonAmount || 0);
    // TODO: data?.ballonAmount is legacy data structure
    this.brokerMargin = parseFloat(data?.brokerMargin || 0);
    this.financeTeam = parseInt(data?.financeTeam || 0, 10);
    this.applicationFees = parseFloat(data?.applicationFees || 0);
  }
}
